import { render, staticRenderFns } from "./contact-us.html?vue&type=template&id=64ef60bc&scoped=true&"
import script from "./contact-us.js?vue&type=script&lang=js&"
export * from "./contact-us.js?vue&type=script&lang=js&"
import style0 from "./contact-us.css?vue&type=style&index=0&id=64ef60bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef60bc",
  null
  
)

export default component.exports